import styled from 'styled-components';

export const YearEvolutionContainer = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: 50% 50%;
`;

export const SaleCardsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  column-gap: 15px;
  align-items: center;
`;

export const SaleCardsContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 20px;
`;

export const SaleCard = styled.div`
  width: auto;
  min-width: 200px;
  height: 170px;
  background-color: #fafbfc;
  border-radius: 15px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const SectionTitle = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: 18px;
  font-weight: 500;
  color: #212632;
`;

export const SaleCardAdminLabel = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: #212632;
`;

export const SaleCardAdminMainValue = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: 20px;
  font-weight: 500;
  color: #212632;
`;
export const SaleCardAdminSecondaryValue = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #747d93;
`;
